import React from 'react';
import {Box, makeStyles, Typography} from '@material-ui/core';
import {useIntl} from 'react-intl';
import DialogUtilization from '@generic/components/ChargerSetDialog/Utilization';

const useStyles = makeStyles((theme) => ({
  header: {
    fontSize: '1.125rem',
    fontWeight: 400,
    marginBottom: theme.spacing(1),
  },
  subheader: {
    fontSize: '1rem',
  },
}));

export default function Utilization({inputs, handleInputChange}) {
  const {formatMessage} = useIntl();
  const classes = useStyles();

  const {chargerSets} = inputs;
  // remove computed charger so it isn't included when we set the charger sets input
  const {charger, ...restOfChargerSet} = chargerSets[0];

  return (
    <Box>
      <Box mb={4}>
        <Typography variant="h2" className={classes.header}>
          {formatMessage({id: 'wizard.planning.utilization.header'})}
        </Typography>
        <Typography className={classes.subheader}>
          {formatMessage({id: 'wizard.planning.utilization.subheader'})}
        </Typography>
      </Box>
      <DialogUtilization
        chargerSet={restOfChargerSet}
        onChangeChargerSet={(newData) =>
          handleInputChange('chargerSets', [{...restOfChargerSet, ...newData}])
        }
      />
    </Box>
  );
}
